import Chart from 'chart.js/auto';
import {AlgoBase} from "./AlgoBase";

export class TritonChartJS extends AlgoBase {

  constructor(target) {
    super("triton", target);
    this.init();
  }

  async init() {

    // TODO change with Triton data when available
    this.algortihmData = await this.buildDataset("data/algorithms/Maestro.csv");

    const ctx = this.$widget.find("canvas");

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.algortihmData.labels,
        datasets: [{
          label: 'Heating', // [dynamic value in loadDataset()],
          data: this.algortihmData.mainDatasets[0],
          animation: false,
          borderColor: '#d82929',
        }, {
          label: 'Cooling', // [dynamic value in loadDataset()],
          data: this.algortihmData.coolingDatasets[0],
          animation: false,
          borderColor: '#205fb1',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0,
            borderColor: '#330808',
            stepped: true,
          }
        },
        scales: {
          x: this.setupXAxis(this.algortihmData.labels.length / 12),
          y: {
            min: 0,
            max: 1,
            ticks: {
              callback: (value, index, ticks) => {
                if (value === 1) return this.getLegendFromCMS(3, 1);
                if (value === 0) return this.getLegendFromCMS(4, 1);
                return ''; // Hide intermediate ticks
              }
            },
          }
        }
      }
    });

    this.loadDataset(0)

    this.initEvents();

    this.ready();
  }

  loadDataset(datasetIndex) {
    const offset = (this.aiEnabled ? 0 : this.getLoopIndex());
    this.chart.data.datasets[1].data = this.algortihmData.coolingDatasets[datasetIndex + offset];

    this.chart.data.datasets[0].label = this.getLegendFromCMS(1, 1);
    this.chart.data.datasets[1].label = this.getLegendFromCMS(2, 1);

    super.loadDataset(datasetIndex);
  }

  async buildDataset(filename) {
    const singleDataSetBuild = await super.buildDatasetFromCSV(filename, 1);

    const heating = [];
    const cooling = [];

    // WITH AI
    heating.push(...singleDataSetBuild.mainDatasets.splice(0, 4))
    cooling.push(...Array.from({length: 4}, () => []));

    heating.push(...Array.from({length: 6}, () => []));
    cooling.push(...singleDataSetBuild.mainDatasets.splice(0, 6))

    // WITHOUT AI
    heating.push(...singleDataSetBuild.mainDatasets.splice(0, 4))
    cooling.push(...Array.from({length: 4}, () => []));

    heating.push(...Array.from({length: 6}, () => []));
    cooling.push(...singleDataSetBuild.mainDatasets.splice(0, 6))

    return {
      labels: singleDataSetBuild.labels,
      mainDatasets: heating,
      coolingDatasets: cooling,
    };
  }
}
